module.exports = __webpack_public_path__ + "static/media/siddharth-bannerghatta-zoo-trip-04.fac09a6b.png";